import { AppBar, Container, Toolbar, Box, IconButton, Button } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import { pages } from "../data/config";

import MenuIcon from "@mui/icons-material/Menu";
import NavbarLogo from "./NavbarLogo";
import MobileNavigationMenu from "./MobileNavigationMenu";

// NAVBAR
export default function Navbar() {
    const [showMobileNavMenu, setMobileNavMenuVisibility] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    // RETURN ELEMENT
    return (
        <>
            {/* MOBILE NAVBAR */}
            {showMobileNavMenu && <MobileNavigationMenu setMobileNavMenuVisibility={setMobileNavMenuVisibility} />}

            {/* NORMAL NAVBAR */}
            <AppBar sx={{ py: 2, boxShadow: 'none', background: 'var(--backgroundcolor2)' }} position="static">
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        {/* DESKTOP / LARGE MONITORS */}
                        <Box sx={{ display: { xs: "none", md: "flex" }, mr: 5, cursor: 'pointer' }} onClick={() => navigate('/home')}>
                            <NavbarLogo imageWidth="65px" />
                        </Box>

                        {/* DESKTOP / LARGE MONITORS */}
                        <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" }, justifyContent: 'flex-end' }}>
                            {pages.map(page => (
                                <Button
                                    href={`${(page.toLowerCase()).replace(/\s/g, '')}`}
                                    key={page}
                                    aria-label={page}
                                    sx={{
                                        '&:hover': {
                                            color: 'var(--teal_brighter)'
                                        },
                                        ml: 2,
                                        fontFamily: 'Public Sans',
                                        fontSize: 19,
                                        textTransform: 'none',
                                        color: (location.pathname === '/' ? '/home' : location.pathname) === `/${page.toLowerCase().replace(/\s/g, '')}` ? 'var(--teal_brighter)' : 'white'
                                    }}
                                >
                                    {page}
                                </Button>
                            ))}
                        </Box>

                        {/* MOBILE / SMALL MONITORS */}
                        <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" }, cursor: 'pointer' }} onClick={() => navigate('/home')}>
                            <NavbarLogo imageWidth="75px" />
                        </Box>

                        {/* MOBILE / SMALL MONITORS */}
                        <Box sx={{ display: { xs: "flex", md: "none" } }}>
                            <IconButton
                                size="large"
                                aria-label="navigation menu"
                                aria-haspopup="true"
                                onClick={() => setMobileNavMenuVisibility(true)}
                            >
                                <MenuIcon sx={{ fontSize: 45 }} />
                            </IconButton>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
        </>
    )
}
